export enum AccountClassificationEnum{
    Unknown = -1,
    Accumulation = 1,
    Pension = 2,
    TTR = 3 ,
    PrePension = 4,
    InsuranceOnly = 5, 
    DefinedBenefit = 6,
    RedundancyTrust = 99
}